import { render, staticRenderFns } from "./LearntAboutVitadioForm.vue?vue&type=template&id=15987168"
import script from "./LearntAboutVitadioForm.vue?vue&type=script&lang=js"
export * from "./LearntAboutVitadioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports